import React, { useEffect } from 'react';

import {
  createSearchParams,
  Navigate,
  Outlet,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { fetchUser } from '../../../store/reducers/actionCreators';
import { landingFor, NAVIGATE_PATH } from '../../../helpers/constants';

const AnonymousRoute: React.FC = () => {
  const { user, isLoading } = useAppSelector((state) => state.userReducer);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
    }

    const inviteState = searchParams.get('inviteState');
    if (inviteState) {
      const inviteStateSplitted = inviteState.split('=');
      if (inviteStateSplitted.length === 2) {
        const [key, value] = inviteStateSplitted;
        navigate({
          pathname: NAVIGATE_PATH.inviteQuery,
          search: `?${createSearchParams({ [key]: value })}`,
        });
        return;
      }
    }

    dispatch(fetchUser());
  }, []);

  if (user || isLoading) {
    const path = searchParams.get('isCheckoutLogin')
      ? NAVIGATE_PATH.checkoutSummary
      : landingFor(user?.role);
    return isLoading ? null : <Navigate to={path} />;
  }
  return <Outlet />;
};

export default AnonymousRoute;
